import { useState } from "react";
import { useLang } from "../context/TranslationProvider";
import MyMainLayout from "./MyMainLayout";
import { Footer } from "../pages/HomePageNeeds/Footer/Footer";
import { useAuth } from "@/context/AuthContext";
import { MyLoader } from "@/components/loaders/SkeletonLoader";

export default function MyHomeLayout({ apps, headerText="Welcome", headerSubText="Choose a service to continue" }: any) {
  const {user} = useAuth();
  const { t, direction } = useLang();

  if(!apps && !apps?.length ) return <MyLoader />

  const [activeApp, setActiveApp] = useState<any>(null);

  // If app opened
  if (activeApp?.component) {
    return (
      <MyMainLayout
        label={activeApp.title}
        main={activeApp.component}
        onBack={() => setActiveApp(null)}
      />
    );
  }

  return (
    <MyMainLayout
      label={t("home")}

      main={

        <div className="space-y-8">

          {/* Welcome */}
          <div className="rounded-2xl bg-gradient-to-r from-indigo-500 to-purple-500 p-6 text-white shadow-sm">

            <h2 className="text-xl md:text-2xl font-semibold">
              {t(headerText)}
            </h2>

            <p className="mt-1 text-sm opacity-90">
              {t(headerSubText)}
            </p>

          </div>


          {/* App Grid */}

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">

            {apps.map((app: any) => {
              const visible = canShowApp(app, user);
              if (!visible) return null;

              return (

              <div
             
                key={app.key}
                className={`group relative flex flex-col items-start gap-4 rounded-2xl p-5 text-left shadow-sm transition bg-white dark:bg-gray-800 hover:shadow-md dark:hover:shadow-gray-900 focus:outline-none
                  ${!app.enabled ? "opacity-50 cursor-not-allowed" : "hover:-translate-y-0.5 dark:hover:bg-gray-750"}`}
              >

                {/* Card Click Area */}

                <div
                  onClick={() => {
                    if (!app.enabled) return;

                    if (app.component) {
                      setActiveApp({
                        ...app,
                        title: app.title
                      });
                    }

                    if (app.href) {
                      window.location.href = app.href;
                    }
                  }}

                  className="w-full flex flex-col items-start gap-4 cursor-pointer"
                >

                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 group-hover:bg-black dark:group-hover:bg-gray-600 group-hover:text-white dark:group-hover:text-white transition">
                  {app.icon}
                </div>

                  <div>
                  <h3 className={`w-full flex justify-start items-center ${direction === "rtl" ? "text-right" : "text-left"} font-semibold text-gray-900 dark:text-gray-100`}>
                    {t(app.title)}
                  </h3>
                  <p className={`w-full flex justify-start items-center ${direction === "rtl" ? "text-right" : "text-left"} text-sm text-gray-500 dark:text-gray-400`}>
                    {t(app.description)}
                  </p>
                </div>

                 {!app.enabled && (
                  <span className="absolute top-3 right-3 rounded-full bg-gray-200 dark:bg-gray-700 px-2 py-0.5 text-xs text-gray-600 dark:text-gray-300">
                    {t("Soon")}
                  </span>
                )}

                </div>


                {/* Child Buttons */}

                {app.children?.length > 0 && (

                  <div className="mt-4 flex flex-wrap gap-2">

                    {app.children.map((child: any, index: number) => (

                      <button
                        key={index}

                        onClick={() =>
                          setActiveApp({
                            title: child.title,
                            component: child.component
                          })
                        }

                        className="text-xs px-3 py-1 rounded-lg bg-gray-100 hover:bg-gray-200 transition"
                      >

                        {child.title}

                      </button>

                    ))}

                  </div>

                )}


                {/* Disabled Label */}

                {!app.enabled && (

                  <span className="absolute top-3 right-3 rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-600">
                    Soon
                  </span>

                )}

              </div>

            )
            })}

          </div>

        </div>

      }

     bottom={<Footer  />}

    />
  );

}


const canShowApp = (app: any, user: any) => {
  if (!("roles" in app)) return true;
  if (app.roles === "any") return true;
  if (!user || !Array.isArray(user.roles)) return false;
  if (Array.isArray(app.roles)) {
    if (app.roles.includes("any")) return true;
    return app.roles.some((role) => user.roles.includes(role));
  }
  return user.roles.includes(app.roles);
};